import React from 'react';
import styles from './Table.module.css';

// Table عام قابل لإعادة الاستخدام
// columns: [{ key: 'name', label: 'الاسم', render: (row) => ... }]
export default function Table({ columns, data, loading, emptyText = 'لا توجد بيانات بعد' }) {
  if (loading) {
    return <div className={styles.state}>جارِ تحميل البيانات...</div>;
  }

  if (!data || data.length === 0) {
    return <div className={styles.state}>{emptyText}</div>;
  }

  return (
    <div className={styles.wrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id}>
              {columns.map((col) => (
                <td key={col.key}>
                  {col.render ? col.render(row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
